import { getAccountSourceListStore, getSourceIdByMailboxInfo } from 'owa-account-source-list-store';
import type { MailboxInfo } from 'owa-client-types';
import { getStore } from '../store/store';

export default function folderNameToId(folderName: string, mailboxInfo?: MailboxInfo): string {
    if (!folderName) {
        throw new Error('Input parameter to folderNameToId must not be null.');
    }

    // Use selected sourceId if mailboxInfo or sourceId related to the mailboxInfo are not available.
    let accountSourceId = getAccountSourceListStore().selectedSourceId;
    if (mailboxInfo) {
        const mailboxInfoSourceId = getSourceIdByMailboxInfo(mailboxInfo);
        if (mailboxInfoSourceId) {
            accountSourceId = mailboxInfoSourceId;
        }
    }

    let folderId;
    if (accountSourceId) {
        folderId = getStore()
            .accountScopeUserSettingsMap.get(accountSourceId)
            ?.defaultFolderNameToIdMap.get(folderName);
    }

    return folderId ?? '';
}
